module.exports = __webpack_public_path__ + "static/img/knowledgenew.4c9749ed.png";